import ServicePageTemplate from "@/components/layout/ServicePageTemplate";

export default function RemodelingPage() {
  return (
    <div data-testid="remodeling-page">
      <ServicePageTemplate
        overline="Remodeling"
        title="Modernize your home with quality remodeling."
        sub="Kitchens, baths and full-home upgrades — completed with clean craftsmanship, durable materials and thoughtful detail."
        image="https://images.pexels.com/photos/10827358/pexels-photo-10827358.jpeg"
        serviceTitle="Remodeling"
        services={[
          "Kitchen Remodeling",
          "Bathroom Remodeling",
          "Window Replacement & Install",
          "Door Installation (Entry, Interior, Sliding)",
          "Flooring Installation",
          "Interior & Exterior Upgrades",
          "Lighting & Fixture Upgrades",
          "Custom Finishes",
          "Drywall & Painting",
        ]}
        benefits={[
          "Increase Home Value",
          "Personalized Design",
          "Quality Materials",
          "Single Accountable Team",
          "Clean Daily Site",
          "On-Schedule Completion",
        ]}
        faq={[
          { q: "Do you do design work?", a: "Yes — we work with you on layouts, finishes and selections. Bring inspiration; we'll help shape it into a build plan." },
          { q: "Can you remodel while we live in the home?", a: "In many cases yes. We isolate the work zone, contain dust and protect your living areas." },
          { q: "How are remodels priced?", a: "By scope and finish level. We'll walk through the project and give a detailed line-item estimate." },
        ]}
      />
    </div>
  );
}
